import {
    getOrder,
    listOrders
} from './queries';
import {
    createOrder,
    deleteOrder,
    updateOrder,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Order} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListOrders = {
    listOrders: { items: Order[], nextToken: string }
}

export type GetOrder = {
    getOrder: Order
}

export type CreateOrder = {
    createOrder: Order
}

export type UpdateOrder = {
    updateOrder: Order
}

export type DeleteOrder = {
    deleteOrder: string
}


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListOrders>>({
                                                                        query: listOrders,
                                                                        variables: {
                                                                            ...query
                                                                        },
                                                                    });
    return {
        items: response.data?.listOrders.items,
        nextToken: response.data?.listOrders.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrder>>({
                                                                      query: getOrder,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getOrder;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateOrder>>({
                                                                         query: createOrder,
                                                                         variables: {input: payload},
                                                                     });
    return response.data?.createOrder;
};

export const update = async (_id: string, record: Order) => {
    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateOrder>>({
                                                                         query: (updateOrder),
                                                                         variables: {input: record},
                                                                     });
    return response.data?.updateOrder;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteOrder>>({
                                                                         query: (deleteOrder),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deleteOrder;
};
